import { Button } from 'primereact/button';
import { useDispatch, useStore } from 'react-redux';
import styles from '../style/chat_backbone_comp.module.css'
import { startMessaging } from '../state/chat_slice';

const ChatFailedInitComp = () => {
    const dispatch = useDispatch();
    const store = useStore();

    const handleTryAgainClick = () => {
        startMessaging(dispatch, store);
    }

    return (
        <div className={`h-dvh flex flex-col items-center justify-center bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950 text-white`}>
            <div className="text-lg">
                Chat Initialization Failed
            </div>
            <Button
                className={`${styles.button} mt-2`}
                loading={false}
                onClick={handleTryAgainClick}>
                Try Again
            </Button>
        </div>
    );
}

export default ChatFailedInitComp;